






















































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class AddressItem extends Vue {
  @Prop() address;

  @Prop() assetId;

  sheet = false;

  handleAddressClick(address) {
    this.$helper.toFusionPath(this, "wallet", {
      name: "withdraw-address",
      query: { addressId: address.address_id, assetId: this.assetId }
    });
  }

  handleDeleteAddress() {
    const url = `mixin://address?action=delete&address=${this.address.address_id}&asset=${this.assetId}`;
    window.location.href = url;
    this.$root.$emit(this.$rootEvents.PIN_ENTER, () => {
      this.$emit("refresh");
    });
  }

  handleEditAddress() {
    this.$helper.toFusionPath(this, "wallet", {
      name: "addresses-id-edit",
      params: { id: this.assetId },
      query: { addressId: this.address.address_id }
    });
  }
}
export default AddressItem;
